import {
  Box,
  Card, CardBody, Flex,
  Spinner,
  TabPanel,
  TabPanels,
  Tabs,
} from '@chakra-ui/react';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { useParams, useSearchParams } from 'react-router-dom';
import EditSidebar from '../../Components/Sidebar/EditSidebar';
import MainPanel from '../../Components/Layouts/MainPanel';
import ContentPanel from '../../Components/Layouts/ContentPanel';
import Editor from '../../Components/FormEditor/Editor/Editor';
import FormSetup from '../../Components/FormSetup';
import { useGetTemplateDraftQuery } from '../../Services/templates';
import EditMenuTemplate from '../../Components/Sidebar/EditMenuTemplate';
import formTemplate from './template';
import TemplateEditorSidebar from '../../Components/FormEditorSidebar/TemplateEditorSidebar';

const tabs = ['setup', 'field', 'end', 'actions', 'publish'];
const getIndex = (searchParams) => {
  const tab = searchParams.get('tab');
  if (!tab) return 0;
  const i = tabs.findIndex((t) => t === tab);
  return i < 0 ? 1 : i;
};
const EditTemplatePage = () => {
  const { templateId } = useParams();

  const { data: template } = useGetTemplateDraftQuery(templateId);
  const [searchParams, setSearchParams] = useSearchParams();

  const handleTabChange = (i) => {
    searchParams.set('tab', tabs[i]);
    setSearchParams(searchParams);
  };

  const form = template ? {
    ...template,
    schema: {
      ...formTemplate,
      ...template.schema,
    },
  } : undefined;

  return (
    <DndProvider backend={HTML5Backend}>
      <Box>
        <Tabs size="xs" variant="unstyled" defaultIndex={getIndex(searchParams)} onChange={handleTabChange}>
          <EditSidebar page="template" name={template?.name} />
          <MainPanel>
            <ContentPanel>
              <Flex direction="column" w="calc(100% - 275px)" position="relative">
                <EditMenuTemplate />
                <Card>
                  <CardBody id="edit">
                    <TabPanels>
                      <TabPanel>
                        <FormSetup />
                      </TabPanel>
                      <TabPanel>
                        {form ? <Editor form={form} /> : (
                          <Flex justifyContent="center">
                            <Spinner
                              thickness="4px"
                              speed="0.65s"
                              emptyColor="gray.200"
                              color="blue.500"
                              size="xl"
                            />
                          </Flex>
                        )}
                      </TabPanel>
                    </TabPanels>
                  </CardBody>
                </Card>
              </Flex>
              <TemplateEditorSidebar />
            </ContentPanel>
          </MainPanel>
        </Tabs>
      </Box>
    </DndProvider>
  );
};
export default EditTemplatePage;
